import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AppUpdateService} from '../../app-update/app-update.service';

@Component({
  selector: 'sm-app-update-progress',
  templateUrl: './sm-app-update-progress.component.html',
  styleUrls: ['./sm-app-update-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SmAppUpdateProgressComponent {
  readonly progress = this.appUpdateService.downloadProgress;

  constructor(private readonly appUpdateService: AppUpdateService) {}
}
